module.exports = __webpack_public_path__ + "static/media/Sciplab-logo.a3c07d83.mp4";